export enum ClientTrackingCategory {
  Language = 'language',
  Authorisation = 'authorisation',
  Decline = 'decline',
  Confirm = 'confirm',
  SendInitialPinCode = 'send_initial_pin_code',
  ResendPinCode = 'resend_pin_code',
  I9FlowTypeRequest = 'i9_flow_type_request',
  Section3Esign = 'section3_esign',
  Section3Decline = 'section3_decline',
  Section3DeclineReason = 'section3_decline_reason',
  Section2Decline = 'section2_decline',
  Section2DeclineReason = 'section2_decline_reason',
  Section2ReuploadDocuments = 'section2_reupload_documents',
  Section2UploadOtherDocuments = 'section2_upload_other_documents',
  DocumentTypes = 'document_types',
  DocumentDetailsChangeTracking = 'document_details_change_tracking',
  ESignResultSuccess = 'e_sign_result_success',
  ESignResultFailure = 'e_sign_result_error',
  ESignResultInvalidRequest = 'e_sign_result_invalid_request',
  LoadDocuments = 'load_documents',
  DocumentValidation = 'document_validation'
}



// WEBPACK FOOTER //
// ./src/models/client-tracking-category.ts